module.exports = __webpack_public_path__ + "static/media/dropbox.9433836d.jpg";